<div mat-dialog-title>
  <eon-ui-icon fxLayout fxLayoutAlign="end" [mat-dialog-close]="false" class=closeX name="close"></eon-ui-icon>
  <div class="headline">{{'delete-device.headline' | translate}}</div>
</div>

<ng-container>
  <mat-dialog-content fxFlex>
    <div>
      <div fxLayout="column">
        <div fxLayoutAlign="center center">
          <mat-icon svgIcon="eon-trash-bin" class="delete-icon"></mat-icon>
        </div>
        <div class="stepheadline" fxLayoutAlign="center center">{{'delete-device.subheadline' | translate}}</div>
        <p fxLayoutAlign="center center" class="confirmation-paragraph">{{'mbus-delete-device.confirmation-paragraph' | translate}}</p>
        <div class="bottom-container" fxLayout="row" fxLayoutAlign="space-around center">
          <div fxLayout="column">
            <div>{{'add-opcua-server-dialog.input.server-address.title' | translate}}</div>
            <p class="stepheadline">{{this.device.serverAddress}}</p>
          </div>
          <div fxLayout="column">
            <div>{{'add-opcua-server-dialog.input.port-number' | translate}}</div>
            <p class="stepheadline">{{this.device.portNumber}}</p>
          </div>
        </div>
      </div>
    </div>
    <p class="confirmation-paragraph" >{{'mbus-delete-device.checkbox-label-description' | translate}}</p>
    <!-- <eon-ui-checkbox [(ngModel)]="deleteDatapoints" label="{{'mbus-delete-device.checkbox-label' | translate}}"></eon-ui-checkbox> -->
  </mat-dialog-content>

  <mat-dialog-actions style="justify-content: space-between;">
    <eon-ui-button scheme="red" rank="secondary" icon="close" text="{{'general.cancel' | translate}}" mat-dialog-close></eon-ui-button>
    <eon-ui-button (click)="deleteDevice()"
                   text="{{'mbus-datapoint-configurator.button.apply' | translate}}"></eon-ui-button>
  </mat-dialog-actions>

</ng-container>
